import { makeStyles, Typography } from '@paintscout/ui'
import React from 'react'
import { formatCurrency, getQuoteOptions } from '@paintscout/util/builder'
import type { OptionsDocument, QuoteDocument } from 'paintscout'
import round from 'lodash/round'

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.typography.h3,
    whiteSpace: 'nowrap',
    '& span': {
      color: theme.palette.text.disabled
    }
  }
}))

export interface PaymentDialogRightContentProps {
  quote: QuoteDocument
  options: OptionsDocument
  paymentAmount: number
  includeSurcharge?: boolean
  currency?: string
  balanceDueOverride?: number
}

export default function PaymentDialogRightContent({
  quote,
  options,
  paymentAmount,
  includeSurcharge,
  currency,
  balanceDueOverride
}: PaymentDialogRightContentProps) {
  const classes = useStyles()
  const { surcharge } = getQuoteOptions({ options, quote })

  const balanceDue = quote?.totals?.balance_due

  const surchargeAmount =
    includeSurcharge && !!surcharge?.enabled && surcharge?.value > 0
      ? round((paymentAmount * surcharge.value) / 100, 2)
      : 0
  const roundedAmount = round(paymentAmount, 2)

  const formattedAmount = formatCurrency({ options, value: roundedAmount + surchargeAmount })
  const formattedBalanceDue = balanceDue
    ? formatCurrency({ options, value: balanceDueOverride ?? balanceDue + surchargeAmount })
    : null
  return (
    <Typography className={classes.root} align={'center'}>
      {formattedAmount} {!!formattedBalanceDue && <span>of {formattedBalanceDue}</span>}
      {currency && <span> {currency}</span>}
    </Typography>
  )
}
